var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
/* eslint-disable no-empty-pattern */
import { IconButton, InputAdornment, Menu, MenuItem, Tooltip, } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { ButtonWrapper } from '../CampaignOversightMainView.Styles';
import { CustomTextField, GridWrapper, TitleWrapper, Wrapper, } from './CampaignOversightListTable.Styles';
import { OversightColumns } from './OversightColumns';
import FilterListIcon from '@material-ui/icons/FilterList';
import { AccessRoles } from '../../../..';
import { controlScheduleExecution } from '../../../..';
import PubSub from 'pubsub-js';
import PlayArrowRoundedIcon from '@material-ui/icons/PlayArrowRounded';
import PauseRoundedIcon from '@material-ui/icons/PauseRounded';
import StopRoundedIcon from '@material-ui/icons/StopRounded';
import { SkipNextRounded } from '@material-ui/icons';
import ReactAGGrid from '../../../commons/ReactAGGrid';
var columns = __spreadArrays(OversightColumns);
export var CampaignOversightListTable = function (_a) {
    var onRowClick = _a.onRowClick, rowData = _a.rowData, accessLevel = _a.accessLevel, accountURL = _a.accountURL;
    var _b = useState(null), filterAnchor = _b[0], setFilterAnchor = _b[1];
    var _c = useState('Schedule Name'), filterName = _c[0], setFilterName = _c[1];
    var _d = useState(''), filterTarget = _d[0], setFilterTarget = _d[1];
    var _e = useState(rowData), myData = _e[0], setMyData = _e[1];
    var _f = React.useState({}), updateState = _f[1];
    var forceUpdate = React.useCallback(function () { return updateState({}); }, []);
    useEffect(function () {
        // forceUpdate();
    }, [accountURL]);
    useEffect(function () {
        var myData = rowData.map(function (rd) { return (__assign(__assign({}, rd), { readOnly: accessLevel === AccessRoles.READ_ONLY ? true : false })); });
        setMyData(myData);
    }, [rowData]);
    var handleFilterMenu = function (event) {
        setFilterAnchor(event.currentTarget);
    };
    var handleCloseFilter = function () {
        setFilterAnchor(null);
    };
    var handleExecution = function (status, malfunctioned) {
        var message = {
            code: '',
            message: '',
            severity: 'success'
        };
        if (malfunctioned) {
            message.severity = 'error';
            switch (status) {
                case 'PAUSED':
                    message.code = 'PAUSED';
                    message.message = 'Pause Failed!';
                    break;
                case 'RUNNING':
                    message.code = 'RUNNING';
                    message.message = 'Start Failed!';
                    break;
                case 'STOPPING':
                    message.code = 'STOPPING';
                    message.message = 'Stop Failed!';
                    break;
                case 'SKIP_SEQUENCE':
                    message.code = 'SKIP_SEQUENCE';
                    message.message = 'Skip Failed!';
                    break;
                default:
                    break;
            }
        }
        else {
            message.severity = 'success';
            switch (status) {
                case 'PAUSED':
                    message.code = 'PAUSED';
                    message.message = 'Pause Success!';
                    break;
                case 'RUNNING':
                    message.code = 'RUNNING';
                    message.message = 'Start Success!';
                    break;
                case 'STOPPING':
                    message.code = 'STOPPING';
                    message.message = 'Stop Success!';
                    break;
                case 'SKIP_SEQUENCE':
                    message.code = 'SKIP_SEQUENCE';
                    message.message = 'Skip Success!';
                    break;
                default:
                    break;
            }
        }
        PubSub.publish('control_schedule_execution', message);
    };
    var eventFilter = function (filterMode) {
        var lowerTarget = filterTarget.toLowerCase();
        switch (filterMode) {
            case 'Schedule Name':
                return myData === null || myData === void 0 ? void 0 : myData.filter(function (event) {
                    var _a;
                    return ((_a = event === null || event === void 0 ? void 0 : event.ScheduleName) === null || _a === void 0 ? void 0 : _a.toLowerCase().indexOf(lowerTarget)) !== -1;
                });
            case 'Campaign Name':
                return myData === null || myData === void 0 ? void 0 : myData.filter(function (event) {
                    var _a, _b;
                    return (((_b = (_a = event === null || event === void 0 ? void 0 : event.CampaignInfo) === null || _a === void 0 ? void 0 : _a.CampaignName) === null || _b === void 0 ? void 0 : _b.toLowerCase().indexOf(lowerTarget)) !== -1);
                });
            case 'Task Queue':
                return myData === null || myData === void 0 ? void 0 : myData.filter(function (event) {
                    var _a, _b;
                    return (((_b = (_a = event === null || event === void 0 ? void 0 : event.TaskQueueStats) === null || _a === void 0 ? void 0 : _a.taskQueueName) === null || _b === void 0 ? void 0 : _b.toLowerCase().indexOf(lowerTarget)) !== -1);
                });
            case 'Status':
                return myData === null || myData === void 0 ? void 0 : myData.filter(function (event) {
                    var _a;
                    return ((_a = event === null || event === void 0 ? void 0 : event.Status) === null || _a === void 0 ? void 0 : _a.toLowerCase().indexOf(lowerTarget)) !== -1;
                });
            case 'Campaign Mode':
                return myData === null || myData === void 0 ? void 0 : myData.filter(function (event) {
                    var _a;
                    return ((_a = event === null || event === void 0 ? void 0 : event.CampaignMode) === null || _a === void 0 ? void 0 : _a.toLowerCase().indexOf(lowerTarget)) !== -1;
                });
            case 'Current Sequence':
                return myData === null || myData === void 0 ? void 0 : myData.filter(function (event) {
                    var _a, _b, _c;
                    return (((_c = (_b = (_a = event === null || event === void 0 ? void 0 : event.ProgressInfo) === null || _a === void 0 ? void 0 : _a.CurrentSequenceInfo) === null || _b === void 0 ? void 0 : _b.CurrentSequenceName) === null || _c === void 0 ? void 0 : _c.toLowerCase().indexOf(lowerTarget)) !== -1);
                });
            default:
                return myData;
        }
    };
    return (React.createElement(Wrapper, null,
        React.createElement(TitleWrapper, null,
            React.createElement(ButtonWrapper, null,
                React.createElement(CustomTextField, { size: 'small', label: "Filter by " + filterName, placeholder: "Filter by " + filterName, variant: 'outlined', InputProps: {
                        endAdornment: (React.createElement(InputAdornment, { position: 'end' },
                            React.createElement(Tooltip, { title: 'Change Filter Criteria', placement: 'top' },
                                React.createElement(IconButton, { onClick: handleFilterMenu },
                                    React.createElement(FilterListIcon, null)))))
                    }, onChange: function (e) { return setFilterTarget(e.target.value); } }),
                React.createElement(Menu, { id: 'filter-menu', open: Boolean(filterAnchor), keepMounted: true, anchorEl: filterAnchor, onClose: handleCloseFilter },
                    React.createElement(MenuItem, { onClick: function () {
                            handleCloseFilter();
                            setFilterName('Schedule Name');
                        } },
                        "Schedule Name",
                        ' '),
                    React.createElement(MenuItem, { onClick: function () {
                            handleCloseFilter();
                            setFilterName('Campaign Name');
                        } }, "Campaign Name"),
                    React.createElement(MenuItem, { onClick: function () {
                            handleCloseFilter();
                            setFilterName('Task Queue');
                        } }, "Task Queue"),
                    React.createElement(MenuItem, { onClick: function () {
                            handleCloseFilter();
                            setFilterName('Status');
                        } }, "Status"),
                    React.createElement(MenuItem, { onClick: function () {
                            handleCloseFilter();
                            setFilterName('Campaign Mode');
                        } }, "Campaign Mode"),
                    React.createElement(MenuItem, { onClick: function () {
                            handleCloseFilter();
                            setFilterName('Current Sequence');
                        } }, "Current Sequence")))),
        React.createElement(GridWrapper, null,
            React.createElement(ReactAGGrid, { name: 'campaignOversight', onRowClicked: function (event, rowData) {
                    onRowClick(rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleExecutionId);
                }, actions: [
                    {
                        icon: function () { return React.createElement(PlayArrowRoundedIcon, null); },
                        tooltip: 'Resume',
                        onClick: function (event, rowData) {
                            if ((rowData === null || rowData === void 0 ? void 0 : rowData.readOnly) === true) {
                                var message = {
                                    severity: 'info',
                                    message: 'Access Denied'
                                };
                                PubSub.publish('control_schedule_execution', message);
                            }
                            else if ((rowData === null || rowData === void 0 ? void 0 : rowData.Status) === 'STOPPING') {
                                var message = {
                                    severity: 'error',
                                    message: 'Schedule Stop is Already in Progress'
                                };
                                PubSub.publish('control_schedule_execution', message);
                            }
                            else if ((rowData === null || rowData === void 0 ? void 0 : rowData.Status) === 'RUNNING') {
                                var message = {
                                    severity: 'info',
                                    message: 'Schedule is Already Running'
                                };
                                PubSub.publish('control_schedule_execution', message);
                            }
                            else {
                                controlScheduleExecution('RESUME', rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleExecutionId)
                                    .then(function () {
                                    handleExecution('RUNNING', false);
                                })["catch"](function () {
                                    handleExecution('RUNNING', true);
                                });
                            }
                        }
                    },
                    {
                        icon: function () { return React.createElement(PauseRoundedIcon, null); },
                        tooltip: 'Pause',
                        onClick: function (event, rowData) {
                            if (rowData === null || rowData === void 0 ? void 0 : rowData.readOnly) {
                                var message = {
                                    severity: 'info',
                                    message: 'Access Denied'
                                };
                                PubSub.publish('control_schedule_execution', message);
                            }
                            else if ((rowData === null || rowData === void 0 ? void 0 : rowData.Status) === 'STOPPING') {
                                var message = {
                                    severity: 'error',
                                    message: 'Schedule Stop is Already in Progress'
                                };
                                PubSub.publish('control_schedule_execution', message);
                            }
                            else if ((rowData === null || rowData === void 0 ? void 0 : rowData.Status) === 'PAUSED') {
                                var message = {
                                    severity: 'info',
                                    message: 'Schedule is Already Paused'
                                };
                                PubSub.publish('control_schedule_execution', message);
                            }
                            else {
                                controlScheduleExecution('PAUSE', rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleExecutionId)
                                    .then(function (data) {
                                    handleExecution('PAUSED', false);
                                })["catch"](function (err) {
                                    console.log(err);
                                    handleExecution('PAUSED', true);
                                });
                            }
                        }
                    },
                    {
                        icon: function () { return React.createElement(SkipNextRounded, null); },
                        tooltip: 'Skip',
                        onClick: function (event, rowData) {
                            var _a, _b, _c, _d;
                            if (rowData === null || rowData === void 0 ? void 0 : rowData.readOnly) {
                                var message = {
                                    severity: 'info',
                                    message: 'Access Denied'
                                };
                                PubSub.publish('control_schedule_execution', message);
                            }
                            else if ((rowData === null || rowData === void 0 ? void 0 : rowData.Status) === 'STOPPING') {
                                var message = {
                                    severity: 'error',
                                    message: 'Schedule Stop is Already in Progress'
                                };
                                PubSub.publish('control_schedule_execution', message);
                            }
                            else if (((rowData === null || rowData === void 0 ? void 0 : rowData.Status) === 'RUNNING' ||
                                (rowData === null || rowData === void 0 ? void 0 : rowData.Status) === 'PAUSED') &&
                                ((_b = (_a = rowData === null || rowData === void 0 ? void 0 : rowData.ProgressInfo) === null || _a === void 0 ? void 0 : _a.ScheduleProgress) === null || _b === void 0 ? void 0 : _b.CurrentSequence) >= ((_d = (_c = rowData === null || rowData === void 0 ? void 0 : rowData.ProgressInfo) === null || _c === void 0 ? void 0 : _c.ScheduleProgress) === null || _d === void 0 ? void 0 : _d.TotalSequences)) {
                                var message = {
                                    severity: 'info',
                                    message: 'Cannot Skip Current Sequence'
                                };
                                PubSub.publish('control_schedule_execution', message);
                            }
                            else {
                                controlScheduleExecution('SKIP_SEQUENCE', rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleExecutionId)
                                    .then(function () {
                                    handleExecution('SKIP_SEQUENCE', false);
                                })["catch"](function () {
                                    handleExecution('SKIP_SEQUENCE', true);
                                });
                            }
                        }
                    },
                    {
                        icon: function () { return React.createElement(StopRoundedIcon, null); },
                        tooltip: 'Stop',
                        onClick: function (event, rowData) {
                            if (rowData === null || rowData === void 0 ? void 0 : rowData.readOnly) {
                                var message = {
                                    severity: 'info',
                                    message: 'Access Denied'
                                };
                                PubSub.publish('control_schedule_execution', message);
                            }
                            else if ((rowData === null || rowData === void 0 ? void 0 : rowData.Status) === 'STOPPING') {
                                var message = {
                                    severity: 'info',
                                    message: 'Schedule Stop is Already in Progress'
                                };
                                PubSub.publish('control_schedule_execution', message);
                            }
                            else {
                                controlScheduleExecution('STOP', rowData === null || rowData === void 0 ? void 0 : rowData.ScheduleExecutionId)
                                    .then(function () {
                                    handleExecution('STOPPING', false);
                                })["catch"](function () {
                                    handleExecution('STOPPING', true);
                                });
                            }
                        }
                    },
                ], columns: OversightColumns, rows: eventFilter(filterName), autoResize: true }))));
};
CampaignOversightListTable.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=CampaignOversightListTable.js.map